import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { Paper } from '@olxbr/design-system'

import AccountDeactivationConfirmationTemplate from '../../templates/AccountDeactivationConfirmationTemplate'
import medias from '../../../util/medias'

const Content = styled(Paper)`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 64px auto;
  max-width: 768px;
  ${medias.small`
    margin: 0;
  `}
`

export const AccountDeactivationConfirmationPage = ({ token }) => (
  <Content>
    <AccountDeactivationConfirmationTemplate token={token} />
  </Content>
)

AccountDeactivationConfirmationPage.propTypes = {
  token: PropTypes.string,
}
